import { render, staticRenderFns } from "./SignInPage.vue?vue&type=template&id=e6455086&scoped=true"
import script from "./SignInPage.vue?vue&type=script&lang=js"
export * from "./SignInPage.vue?vue&type=script&lang=js"
import style0 from "./SignInPage.vue?vue&type=style&index=0&id=e6455086&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6455086",
  null
  
)

export default component.exports